import { hero } from "../utils/data";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const Hero = () => (
  <section id="top" className="border-b border-paper-300 pt-[72px]">
    {/* Tight, editorial: the headline sits close under the header */}
    <div className="mx-auto max-w-shell px-6 pb-20 pt-10 lg:px-10 lg:pb-28 lg:pt-16">
      <div className="mx-auto flex max-w-4xl flex-col items-center text-center">
        {/* Static availability line — a quiet data label, no pulse */}
        <p className="mb-8 inline-flex items-center gap-2.5 font-mono text-micro uppercase text-ink-500">
          <span className="h-1.5 w-1.5 rounded-full bg-clay" aria-hidden />
          {hero.available}
        </p>

        <h1 className="display text-display-lg text-ink-950">
          {hero.lines.map((line) => (
            <span key={line} className="block">
              {line}
            </span>
          ))}
          <span className="block">
            {hero.tail}
            <span className="text-clay">{hero.accent}</span>
          </span>
        </h1>

        <p className="mt-8 max-w-2xl text-balance text-base leading-relaxed text-ink-600 sm:text-lg">
          {hero.desc}
        </p>

        <div className="mt-10 flex flex-col items-center gap-5 sm:flex-row sm:gap-8">
          <button
            onClick={() => scrollTo("work")}
            className="bg-ink-950 px-8 py-4 font-display text-body font-semibold text-paper transition-colors hover:bg-clay"
          >
            The work
          </button>
          <a
            href={hero.cvHref}
            download
            className="font-display text-body font-semibold text-ink-950 underline decoration-clay decoration-2 underline-offset-4 transition-colors hover:text-clay"
          >
            Download CV
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default Hero;
